import { useTranslation } from 'react-i18next'

import { Select } from '@/components/selects/Select'
import { Typography } from '@/components/Typography'
import { EmailReportIntervalType, I18N_PREFIX } from '@/pages/EmailReport/EmailReport'

interface DeliveryDaySelectProps {
  selectedInterval?: EmailReportIntervalType
  value?: number | null
  onChange?: (value: number | null) => void
}

export function DeliveryDaySelect({ selectedInterval, value, onChange }: DeliveryDaySelectProps) {
  const { t } = useTranslation()

  const weekDayOptions = Array.from({ length: 7 }).map((_, index) => ({
    label: t(`${I18N_PREFIX}.deliveryDay.weekly.${index}`),
    value: String(index),
  }))

  const monthlyDayOptions = Array.from({ length: 31 }).map((_, index) => {
    return {
      label: t(`${I18N_PREFIX}.deliveryDay.monthly.${index + 1}`),
      value: String(index + 1),
    }
  })

  function handleChangeSelectValue(value: `${number}`) {
    onChange?.(Number(value))
  }

  const shouldShowSuffix =
    selectedInterval === EmailReportIntervalType.weekly ||
    selectedInterval === EmailReportIntervalType.monthly

  const selectProps = {
    value: value?.toString(),
    onChange: handleChangeSelectValue,
  }

  return (
    <>
      {shouldShowSuffix && (
        <Typography.Text>
          {t(`${I18N_PREFIX}.form.sections.general.frequency.suffix`)}
        </Typography.Text>
      )}
      {selectedInterval === EmailReportIntervalType.weekly ? (
        <Select {...selectProps} options={weekDayOptions} />
      ) : selectedInterval === EmailReportIntervalType.monthly ? (
        <Select {...selectProps} options={monthlyDayOptions} />
      ) : null}
    </>
  )
}
